"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Refund = exports.RefundStatus = exports.RefundRequestType = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const customer_entity_1 = require("../customers/customer.entity");
const user_entity_1 = require("../users/user.entity");
const order_entity_1 = require("../orders/order.entity");
var RefundRequestType;
(function (RefundRequestType) {
    RefundRequestType["MEDICINE_ISSUE"] = "medicine_issue";
    RefundRequestType["REGISTRATION_CANCEL"] = "registration_cancellation";
    RefundRequestType["RETURN_EXCHANGE"] = "return_exchange";
})(RefundRequestType || (exports.RefundRequestType = RefundRequestType = {}));
var RefundStatus;
(function (RefundStatus) {
    RefundStatus["PENDING"] = "pending";
    RefundStatus["TEAM_LEAD_REVIEW"] = "team_lead_review";
    RefundStatus["MANAGEMENT_REVIEW"] = "management_review";
    RefundStatus["APPROVED"] = "approved";
    RefundStatus["REFUNDED"] = "refunded";
    RefundStatus["REJECTED"] = "rejected";
})(RefundStatus || (exports.RefundStatus = RefundStatus = {}));
let Refund = class Refund {
};
exports.Refund = Refund;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Refund.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)({ unique: true }),
    (0, typeorm_1.Column)({ length: 20 }),
    tslib_1.__metadata("design:type", String)
], Refund.prototype, "refundNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => customer_entity_1.Customer, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof customer_entity_1.Customer !== "undefined" && customer_entity_1.Customer) === "function" ? _a : Object)
], Refund.prototype, "customer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => order_entity_1.Order, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof order_entity_1.Order !== "undefined" && order_entity_1.Order) === "function" ? _b : Object)
], Refund.prototype, "relatedOrder", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _c : Object)
], Refund.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _d : Object)
], Refund.prototype, "teamLeadReviewedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _e : Object)
], Refund.prototype, "managementReviewedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: RefundRequestType }),
    tslib_1.__metadata("design:type", String)
], Refund.prototype, "requestType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: RefundStatus, default: RefundStatus.PENDING }),
    tslib_1.__metadata("design:type", String)
], Refund.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text' }),
    tslib_1.__metadata("design:type", String)
], Refund.prototype, "reason", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Refund.prototype, "patientMedicalConcern", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Refund.prototype, "requestedAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Refund.prototype, "approvedAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 50, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Refund.prototype, "refundMethod", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Refund.prototype, "teamLeadRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Refund.prototype, "managementRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Refund.prototype, "finalRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], Refund.prototype, "teamLeadReviewedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], Refund.prototype, "managementReviewedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], Refund.prototype, "refundedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_j = typeof Date !== "undefined" && Date) === "function" ? _j : Object)
], Refund.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_k = typeof Date !== "undefined" && Date) === "function" ? _k : Object)
], Refund.prototype, "updatedAt", void 0);
exports.Refund = Refund = tslib_1.__decorate([
    (0, typeorm_1.Entity)('refunds')
], Refund);
